import React from 'react';
import { useMutation } from '@apollo/client';
import { RECORD_LESSON_VIEW } from '../../../queries';
import { useHubPetParent } from '../HubPetParentContext';

export type LessonViewSource = 'hub' | 'learning';

// Writes one lesson_view row per lesson opened, which the AWO Engagement tab counts
// as "Lessons reviewed" (ticket-2542). Held until the pet parent resolves so the
// row is attributed, and fire-and-forget: a failed write must never touch the page.
// Repeat opens are deduplicated per day by the report, not here.
export default function useRecordLessonView(slug: string | undefined, source: LessonViewSource) {
  const { petParent } = useHubPetParent();
  const [recordLessonView] = useMutation(RECORD_LESSON_VIEW);
  const petParentId = petParent?.id;

  React.useEffect(() => {
    if (!slug || !petParentId) return;
    recordLessonView({ variables: { slug, source } }).catch(() => {});
  }, [slug, source, petParentId, recordLessonView]);
}
